import { makeAutoObservable, runInAction } from "mobx";
import { SearchFilter, SelectFilterItem } from "@/components/filters";
import { CORP_COMPANY_STATUS_LABELS } from "@/types/corp/corpSession.common";
import { onB2BError } from "@/utils/b2bErrors";
import { DataTableStore } from "./DataTableStore";
import { FiltersStore } from "./FiltersStore";
// FR-006: список корпоративных клиентов (UC1111). Backs CompaniesPage.
export class CompaniesStore {
    constructor(companyService) {
        this.companyService = companyService;
        /** Компании, в которые можно добавить привязку (не в архиве) — выбор в «Компаниях клиента» (UC1117). */
        this.companyOptions = [];
        this.companyOptionsLoading = false;
        this.initializeFilters = () => {
            const filterItems = [
                {
                    id: "company-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Название или ИНН",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
                {
                    id: "company-status-filter",
                    Cmp: SelectFilterItem,
                    props: {
                        name: "status",
                        label: "Статус",
                        placeholder: "Все статусы",
                        mode: "single",
                        options: Object.entries(CORP_COMPANY_STATUS_LABELS).map(([value, label]) => ({ value, label })),
                        onChange: (value) => this.filtersStore.updateFilter("status", value),
                    },
                    visible: true,
                    order: 2,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadCompanies(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeFilters();
        makeAutoObservable(this);
    }
    loadCompanies(params) {
        return this.companyService.getCompanies(params);
    }
    async loadCompanyOptions() {
        this.companyOptionsLoading = true;
        try {
            const options = await this.companyService.getCompanyOptions();
            runInAction(() => {
                this.companyOptions = options;
            });
        }
        catch (error) {
            onB2BError(error, "Не удалось загрузить список компаний");
        }
        finally {
            runInAction(() => {
                this.companyOptionsLoading = false;
            });
        }
    }
}
